<template>
  <div class="monitor-banner">
    <img :src="monitorBanner" alt="" />
    <div class="absolute">
      <div class="title">智能监控</div>
      <div class="text">嵌入式视频服务器中，集成了智能行为识别算法，能够对画面场景中的行人或车辆的行为进行识别、判断</div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import monitorBanner from "../../../../assets/programme/monitorBanner.png";

export default {
  setup() {
    return reactive({
      monitorBanner: monitorBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.monitor-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .monitor-banner {
    min-width: 1180px;
  }
}
.monitor-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248EFB;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248EFB;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #248EFB;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248EFB;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
